var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('actions-toolbar'),_vm._v(" "),_c('v-divider'),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('form-field',{attrs:{"field":_vm.subject}})],1)],1),_c('v-card',{attrs:{"elevation":"3"}},[_c('div',{staticClass:"mar-6"},[_c('message-editable',{attrs:{"index":"0"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }